// extracted by mini-css-extract-plugin
module.exports = {"feed":"styles_feed__1ekar"};